<template>
	<div>
		<el-row style="margin-top: -30px">
			<el-col :span="24">
				<div>
					<el-row>
						<el-col :span="15" :offset="5">
							<el-row>
								<el-col style="margin-top: -40px" :span="3">
									<el-button
										:disabled="current_category_index == 0"
										@click="prev_category()"
										class="button-class"
										icon="el-icon-caret-left"
									>
										Prev
									</el-button>
								</el-col>
								<el-col :span="20">
									<div
										style="
											font-size: 15px;
											font-weight: bold;
											text-align: center;
										"
									>
										{{ current_category_item.form_category_info.name }}
									</div>
								</el-col>
								<el-col style="margin-top: -40px" :span="3">
									<el-button
										@click="next_category()"
										:disabled="
											tableDataActiveCategory.length - 1 ==
											current_category_index
										"
										class="button-class"
										icon="el-icon-caret-right"
									>
										Next
									</el-button>
								</el-col>
							</el-row>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="15" :offset="5">
							<el-card style="border-bottom: none; padding: 0px" shadow="none">
								<el-row>
									<el-col :span="20">
										<div style="font-size: 14px; font-weight: bold">
											<u>{{ formDetails.form_info.name }}</u>
											<!-- <div style="color: black; font-weight: normal">
											Steps -
											{{
												formDetails.task_status_update_info.completed != null
													? formDetails.task_status_update_info.completed
													: 0
											}}
											/
											{{ formDetails.task_status_update_info.total }} completed
										</div> -->
										</div>
									</el-col>
									<el-col :span="4">
										<b
											>Points -
											{{
												Question_form_Details.scoring_type == "all_pass"
													? all_pass_current_question_points
													: current_question_points
											}}
											of
											{{
												Question_form_Details.scoring_type == "all_pass"
													? Question_form_Details.total_points
													: total_points
											}}</b
										>
									</el-col>
								</el-row>
							</el-card>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="15" :offset="5">
							<el-card style="border-top: none; padding: 0px" shadow="none">
								<div style="text-align: center">
									<el-row>
										<el-col
											v-if="formDetails.form_info.show_mark_all_yes_no"
											:span="2"
											:offset="0"
										>
											<div
												@click="button_condition_yes_to_all()"
												style="
													width: 100%;
													height: 40px;
													text-align: center;
													border-radius: 12px;
													border-color: #d26300;
													color: #d26300;
													border: 1px solid;
													cursor: pointer;
												"
												:style="green_color"
											>
												<div style="padding-top: 10px">Yes All</div>
											</div>
										</el-col>
										<el-col
											v-if="formDetails.form_info.show_mark_all_yes_no"
											:span="2"
											style="margin-left: 10px"
										>
											<div
												@click="button_condition_no_to_all()"
												style="
													width: 100%;
													height: 40px;
													text-align: center;
													border-radius: 12px;
													border-color: #d26300;
													color: #d26300;
													border: 1px solid;
													cursor: pointer;
												"
												:style="red_color"
											>
												<div style="padding-top: 10px">No All</div>
											</div>
										</el-col>
										<el-col
											v-if="formDetails.form_info.show_clear_button"
											:span="2"
											style="margin-left: 10px"
										>
											<div
												@click="clear_all_selection()"
												style="
													width: 100%;
													height: 40px;
													text-align: center;
													color: #d26300;
													border: none;
													cursor: pointer;
												"
											>
												<div style="padding-top: 10px">Clear All</div>
											</div>
										</el-col>
										<el-col
											v-if="formDetails.form_info.show_mark_all_na"
											:span="2"
											:offset="
												formDetails.form_info.show_mark_all_yes_no ? 14 : 20
											"
										>
											<span style="margin-left: -10px">NA All</span>
										</el-col>
										<el-col
											v-if="formDetails.form_info.show_mark_all_na"
											:span="1"
										>
											<el-switch
												@change="show_mark_all_na_method"
												v-model="show_mark_all_na"
												active-color="#41BE62"
												style="margin-left: -5px"
											>
											</el-switch>
										</el-col>
									</el-row>
								</div>
							</el-card>
						</el-col>
					</el-row>
					<el-row v-loading="isloading">
						<el-col
							:span="15"
							:offset="5"
							style="height: 64vh; overflow-y: auto"
						>
							<div
								style="margin-top: 20px"
								v-for="(itemS, idxS) in preview_formItemArray"
								:key="idxS"
							>
								<el-row>
									<el-col :span="24">
										<div style="font-size: 14px; font-weight: bold">
											{{ idxS + 1 }}. {{ itemS.section_info.name }}
										</div>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="24">
										<div style="border: 1px solid" class="my-2"></div>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="24">
										<div v-for="(item, idx) in itemS.que_list" :key="idx">
											<el-row>
												<el-col :span="24">
													<el-row>
														<el-col :span="24">
															<div
																style="
																	border: 1px solid;
																	border-color: #f9a168;
																	margin-bottom: 10px;
																	border-radius: 2px;
																"
															>
																<el-card shadow="never">
																	<el-row>
																		<el-col
																			v-if="
																				item.form_question_info.input_type_info
																					.name == 'Checklist'
																			"
																			:span="1"
																		>
																			<span style="margin-left: 20px">
																				<input
																					:disabled="item.marked_as_na"
																					type="checkbox"
																					style="width: 17px; height: 17px"
																					v-model="item.checked"
																				/>
																			</span>
																		</el-col>
																		<el-col
																			:span="
																				item.form_question_info.input_type_info
																					.name == 'Checklist'
																					? 1
																					: 1
																			"
																		>
																			<div
																				style="font-size: 14px"
																				:style="
																					item.form_question_info
																						.input_type_info.name == 'Checklist'
																						? 'margin-left: 10px'
																						: 'margin-left: 10px'
																				"
																			>
																				<b>{{ idx + 1 }}.</b>
																			</div>
																		</el-col>
																		<el-col
																			:span="
																				item.form_question_info.input_type_info
																					.name == 'Checklist'
																					? 18
																					: 18
																			"
																		>
																			<span
																				>{{ item.form_question_info.name }}
																			</span>
																			<span
																				v-if="
																					item.form_question_info.is_critical
																				"
																				style="
																					color: #ff4d4d;
																					font-weight: bolder;
																					font-size: 12px;
																					margin-left: 10px;
																				"
																				>(critical)</span
																			>
																			<span
																				v-if="
																					item.form_question_info
																						.input_type_info.name ==
																						'Checklist' ||
																					item.form_question_info
																						.input_type_info.name ==
																						'Select any one' ||
																					item.form_question_info
																						.input_type_info.name ==
																						'Multiselect'
																				"
																			>
																				<span
																					v-if="item.marked_as_na == false"
																					@click="clear_selection(item, idx)"
																					style="
																						width: 65px;
																						height: 40px;
																						text-align: center;
																						color: #d26300;
																						border: none;
																						cursor: pointer;
																					"
																				>
																					<span
																						style="
																							padding: 0px 10px 10px 10px;
																							font-size: 10px;
																						"
																					>
																						Clear
																					</span>
																				</span>
																			</span>
																			<!-- <span
																				v-if="
																					item.form_question_info
																						.input_type_info.name ==
																						'Temperature' ||
																					item.form_question_info
																						.input_type_info.name == 'TPM'
																				"
																				style="
																					margin-left: 30px;
																					font-weight: 300;
																					font-size: 13px;
																				"
																				>(Ideal Range:
																				{{
																					item.form_question_info.minimum_value
																				}}° C to
																				{{
																					item.form_question_info.maximum_value
																				}}° C)</span
																			> -->
																		</el-col>
																		<el-col
																			v-if="
																				item.form_question_info.description !=
																					null &&
																				item.form_question_info.description.trim() !=
																					''
																			"
																			:span="1"
																		>
																			<el-popover
																				placement="right-start"
																				width="450"
																				trigger="hover"
																			>
																				<div
																					slot="reference"
																					style="
																						word-break: break-word;
																						line-height: 120%;
																					"
																				>
																					<i
																						style="color: #d26300"
																						class="el-icon-info"
																					></i>
																				</div>

																				<div
																					style="
																						font-size: 13px;
																						word-break: break-word;
																					"
																					v-html="
																						item.form_question_info.description
																					"
																				></div>
																			</el-popover>
																		</el-col>
																		<el-col
																			style="margin-top: -10px"
																			v-if="
																				item.form_question_info.input_type_info
																					.name == 'Yes / No'
																			"
																			:span="3"
																			:offset="1"
																		>
																			<div
																				v-if="
																					Question_form_Details.scoring_type !=
																					'all_pass'
																				"
																				style="font-size: 13px"
																			>
																				Points -
																				{{
																					item.current_question_points !=
																						null ||
																					item.current_question_points !=
																						undefined
																						? item.current_question_points
																						: 0
																				}}
																				of
																				{{ item.total_points }}
																			</div>
																		</el-col>
																	</el-row>
																	<!-- <el-row style="margin-top: 5px">
																	<el-col :span="24">
																		<div
																			style="font-size: 13px; margin-left: 37px"
																			
																		></div>
																	</el-col>
																</el-row> -->
																	<el-row
																		v-if="
																			item.form_question_info
																				.form_question_attachments_list
																				.length != 0
																		"
																		style="margin-left: 37px; margin-top: 10px"
																	>
																		<el-col :span="4">
																			<span>
																				<div
																					@click="
																						get_image(
																							item.form_question_info
																								.form_question_attachments_list
																						)
																					"
																					style="
																						color: #f9a168;
																						font-size: 13px;
																					"
																				>
																					<b><u>View Media</u></b>
																					<img
																						style="margin-left: 5px"
																						width="15px"
																						src="../../../../assets/icons/Attach.png"
																					/>
																				</div>
																			</span>
																		</el-col>
																	</el-row>
																	<!-- types -->
																	<el-row
																		style="margin-top: 20px"
																		v-if="
																			item.form_question_info.input_type_info
																				.name == 'Yes / No'
																		"
																	>
																		<el-col
																			v-if="item.marked_as_na == false"
																			:span="2"
																			:offset="1"
																		>
																			<div
																				@click="button_condition_yes(item, idx)"
																				style="
																					width: 100%;
																					height: 40px;
																					text-align: center;
																					border-radius: 12px;
																					border-color: #d26300;
																					color: #d26300;
																					border: 1px solid;
																					cursor: pointer;
																				"
																				:style="item.green_color"
																			>
																				<div style="padding-top: 10px">Yes</div>
																			</div>
																		</el-col>
																		<el-col
																			v-if="item.marked_as_na == false"
																			:span="2"
																			style="margin-left: 10px"
																		>
																			<div
																				@click="button_condition_no(item, idx)"
																				style="
																					width: 100%;
																					height: 40px;
																					text-align: center;
																					border-radius: 12px;
																					border-color: #d26300;
																					color: #d26300;
																					border: 1px solid;
																					cursor: pointer;
																				"
																				:style="item.red_color"
																			>
																				<div style="padding-top: 10px">No</div>
																			</div>
																		</el-col>
																		<el-col
																			v-if="item.marked_as_na == false"
																			:span="2"
																			style="margin-left: 10px"
																		>
																			<div
																				@click="clear_selection(item, idx)"
																				style="
																					width: 100%;
																					height: 40px;
																					text-align: center;
																					color: #d26300;
																					border: none;
																					cursor: pointer;
																				"
																			>
																				<div style="padding-top: 10px">
																					Clear
																				</div>
																			</div>
																		</el-col>
																		<el-col
																			:span="2"
																			:offset="1"
																			v-if="item.marked_as_na"
																		>
																			<el-button
																				disabled
																				style="
																					width: 100%;
																					height: 40px;
																					text-align: center;
																					border-radius: 12px;
																					border-color: #d26300;
																					color: #d26300;
																					border: 1px solid;
																					cursor: pointer;
																					background-color: #d3d3d3;
																					padding: 0px 0px 0px 0px;
																				"
																			>
																				Yes
																			</el-button>
																		</el-col>
																		<el-col
																			:span="2"
																			style="margin-left: 10px"
																			v-if="item.marked_as_na"
																		>
																			<el-button
																				disabled
																				style="
																					width: 100%;
																					height: 40px;
																					text-align: center;
																					border-radius: 12px;
																					border-color: #d26300;
																					color: #d26300;
																					border: 1px solid;
																					cursor: pointer;
																					background-color: #d3d3d3;
																					padding: 0px 0px 0px 0px;
																				"
																			>
																				No
																			</el-button>
																		</el-col>
																	</el-row>
																	<el-row
																		style="margin-top: 20px"
																		v-if="
																			item.form_question_info.input_type_info
																				.name == 'Long text'
																		"
																	>
																		<el-col :span="20" :offset="1">
																			<el-input
																				:disabled="item.marked_as_na"
																				type="textarea"
																				:rows="4"
																				placeholder="Enter long description"
																				v-model="item.text_input"
																				class="input-class"
																				:minlength="0"
																				:maxlength="350"
																				show-word-limit
																			>
																			</el-input>
																		</el-col>
																		<el-col
																			v-if="item.marked_as_na == false"
																			:span="2"
																			:offset="1"
																		>
																			<div
																				@click="clear_selection(item, idx)"
																				style="
																					width: 65px;
																					height: 40px;
																					text-align: center;
																					color: #d26300;
																					border: none;
																					cursor: pointer;
																				"
																			>
																				<div style="padding-top: 10px">
																					Clear
																				</div>
																			</div>
																		</el-col>
																	</el-row>
																	<el-row
																		style="margin-top: 20px"
																		v-if="
																			item.form_question_info.input_type_info
																				.name == 'Short text'
																		"
																	>
																		<el-col :span="20" :offset="1">
																			<el-input
																				:disabled="item.marked_as_na"
																				type="text"
																				v-model="item.text_input"
																				placeholder="Enter short description"
																				class="input-class"
																			/>
																		</el-col>
																		<el-col
																			v-if="item.marked_as_na == false"
																			:span="2"
																			:offset="1"
																		>
																			<div
																				@click="clear_selection(item, idx)"
																				style="
																					width: 65px;
																					height: 40px;
																					text-align: center;
																					color: #d26300;
																					border: none;
																					cursor: pointer;
																				"
																			>
																				<div style="padding-top: 10px">
																					Clear
																				</div>
																			</div>
																		</el-col>
																	</el-row>
																	<el-row
																		style="margin-top: 20px"
																		v-if="
																			item.form_question_info.input_type_info
																				.name == 'Number input'
																		"
																	>
																		<el-col :span="12" :offset="1">
																			<el-input
																				:disabled="item.marked_as_na"
																				type="number"
																				v-model="item.number_input"
																				placeholder="Enter number"
																				class="input-class"
																			/>
																		</el-col>
																		<el-col
																			v-if="item.marked_as_na == false"
																			:span="2"
																			:offset="1"
																		>
																			<div
																				@click="clear_selection(item, idx)"
																				style="
																					width: 65px;
																					height: 40px;
																					text-align: center;
																					color: #d26300;
																					border: none;
																					cursor: pointer;
																				"
																			>
																				<div style="padding-top: 10px">
																					Clear
																				</div>
																			</div>
																		</el-col>
																	</el-row>
																	<el-row
																		style="margin-top: 20px"
																		v-if="
																			item.form_question_info.input_type_info
																				.name == 'Temperature'
																		"
																	>
																		<el-col :span="3" :offset="1">
																			<span>Test Value</span>
																		</el-col>
																		<el-col :span="5">
																			<el-input
																				:disabled="item.marked_as_na"
																				@input="
																					get_temperature_content(
																						item,
																						item.number_input
																					)
																				"
																				type="text"
																				v-model="item.number_input"
																				placeholder="Enter Temperature"
																				:style="item.test_color"
																				:class="
																					item.test_color == '#FF0000'
																						? 'input-class-red'
																						: 'input-class'
																				"
																				style="background: white"
																			/>
																		</el-col>
																		<el-col
																			v-if="item.show_temp_retest"
																			:span="4"
																			:offset="1"
																		>
																			<span>Retest Value</span>
																		</el-col>
																		<el-col
																			v-if="item.show_temp_retest"
																			:span="5"
																		>
																			<span>
																				<el-input
																					:disabled="item.marked_as_na"
																					@input="
																						get_temperature_content_retest(
																							item,
																							item.repeat_number_input
																						)
																					"
																					type="text"
																					v-model="item.repeat_number_input"
																					placeholder="Enter Temperature"
																					:style="item.test_color_retest"
																					:class="
																						item.test_color_retest == '#FF0000'
																							? 'input-class-red'
																							: 'input-class'
																					"
																					style="background: white"
																				/>
																			</span>
																		</el-col>
																		<el-col
																			v-if="item.marked_as_na == false"
																			:span="2"
																			:offset="1"
																		>
																			<div
																				@click="clear_selection(item, idx)"
																				style="
																					width: 65px;
																					height: 40px;
																					text-align: center;
																					color: #d26300;
																					border: none;
																					cursor: pointer;
																				"
																			>
																				<div style="padding-top: 10px">
																					Clear
																				</div>
																			</div>
																		</el-col>
																	</el-row>
																	<el-row
																		v-if="
																			item.form_question_info.input_type_info
																				.name == 'TPM'
																		"
																	>
																		<el-col :span="3" :offset="1">
																			<span>Test Value</span>
																		</el-col>
																		<el-col :span="5">
																			<el-input
																				:disabled="item.marked_as_na"
																				@input="
																					get_tpm_content(
																						item,
																						item.number_input
																					)
																				"
																				type="text"
																				v-model="item.number_input"
																				placeholder="Enter TPM"
																				:style="item.test_color_tpm"
																				:class="
																					item.test_color_tpm == '#FF0000'
																						? 'input-class-red'
																						: 'input-class'
																				"
																				style="background: white"
																			/>
																		</el-col>
																		<el-col
																			v-if="item.show_tpm_retest"
																			:span="4"
																			:offset="1"
																		>
																			<span>Retest Value</span>
																		</el-col>
																		<el-col
																			v-if="item.show_tpm_retest"
																			:span="5"
																		>
																			<el-input
																				:disabled="item.marked_as_na"
																				@input="
																					get_tpm_content_retest(
																						item,
																						item.repeat_number_input
																					)
																				"
																				type="text"
																				v-model="item.repeat_number_input"
																				placeholder="Enter TPM"
																				:style="item.test_color_tpm_retest"
																				:class="
																					item.test_color_tpm_retest ==
																					'#FF0000'
																						? 'input-class-red'
																						: 'input-class'
																				"
																			/>
																		</el-col>
																		<el-col
																			v-if="item.marked_as_na == false"
																			:span="2"
																			:offset="1"
																		>
																			<div
																				@click="clear_selection(item, idx)"
																				style="
																					width: 65px;
																					height: 40px;
																					text-align: center;
																					color: #d26300;
																					border: none;
																					cursor: pointer;
																				"
																			>
																				<div style="padding-top: 10px">
																					Clear
																				</div>
																			</div>
																		</el-col>
																	</el-row>
																	<div
																		v-if="
																			item.form_question_info.input_type_info
																				.name == 'Select any one'
																		"
																	>
																		<el-row
																			v-for="(obj, key) in item
																				.form_question_info.input_options_list"
																			:key="key"
																			class="mb-3 mt-3"
																		>
																			<el-col :span="20" :offset="1">
																				<el-radio
																					:disabled="item.marked_as_na"
																					@change="
																						get_radio_active(
																							obj.id,
																							obj,
																							item.form_question_info
																								.input_options_list
																						)
																					"
																					v-model="obj.checked"
																					:label="obj.id"
																					>{{ obj.name }}</el-radio
																				>
																				<span
																					style="
																						font-size: 12px;
																						margin-left: 20px;
																					"
																				>
																					<b>Points - {{ obj.value }}</b>
																				</span>
																			</el-col>
																		</el-row>
																	</div>
																	<div
																		v-if="
																			item.form_question_info.input_type_info
																				.name == 'Multiselect'
																		"
																	>
																		<el-row
																			class="mt-3 mb-3"
																			v-for="(obj, key) in item
																				.form_question_info.input_options_list"
																			:key="key"
																		>
																			<el-col :span="1" :offset="1">
																				<input
																					:disabled="item.marked_as_na"
																					type="checkbox"
																					style="width: 17px; height: 17px"
																					v-model="obj.selected"
																				/>
																			</el-col>
																			<el-col :span="23">
																				<span
																					style="
																						margin-top: -3px;
																						margin-left: -10px;
																					"
																				>
																					{{ obj.name }}
																				</span>
																				<span
																					style="
																						margin-top: 0px;
																						margin-left: 20px;
																						font-size: 12px;
																					"
																				>
																					<b>Points - {{ obj.value }}</b>
																				</span>
																			</el-col>
																		</el-row>
																	</div>
																	<el-row
																		style="margin-top: 10px"
																		v-if="
																			item.form_question_info.input_type_info
																				.name == 'Date'
																		"
																	>
																		<el-col :span="7" :offset="1">
																			<el-date-picker
																				style="margin-top: 10px; width: 95%"
																				v-model="item.date_input"
																				type="date"
																				placeholder="Select Date"
																				class="date"
																				format="yyyy-MM-dd"
																				value-format="yyyy-MM-dd"
																			>
																			</el-date-picker>
																		</el-col>
																		<el-col
																			v-if="item.marked_as_na == false"
																			:span="2"
																			:offset="1"
																		>
																			<div
																				@click="clear_selection(item, idx)"
																				style="
																					width: 65px;
																					height: 40px;
																					text-align: center;
																					color: #d26300;
																					border: none;
																					cursor: pointer;
																				"
																			>
																				<div style="padding-top: 10px">
																					Clear
																				</div>
																			</div>
																		</el-col>
																	</el-row>
																	<el-row
																		style="margin-top: 10px"
																		v-if="
																			item.form_question_info.input_type_info
																				.name == 'Time'
																		"
																	>
																		<el-col :span="7" :offset="1">
																			<el-time-select
																				v-model="item.time_input"
																				:picker-options="{
																					start: '00:00',
																					step: '00:15',
																					end: '23:45',
																				}"
																				placeholder="Select time"
																				class="date"
																			>
																			</el-time-select>
																		</el-col>
																		<el-col
																			v-if="item.marked_as_na == false"
																			:span="2"
																			:offset="1"
																		>
																			<div
																				@click="clear_selection(item, idx)"
																				style="
																					width: 65px;
																					height: 40px;
																					text-align: center;
																					color: #d26300;
																					border: none;
																					cursor: pointer;
																				"
																			>
																				<div style="padding-top: 10px">
																					Clear
																				</div>
																			</div>
																		</el-col>
																	</el-row>
																	<el-row
																		style="margin-top: 10px"
																		v-if="
																			item.form_question_info.input_type_info
																				.name == 'Datetime'
																		"
																	>
																		<el-col :span="7" :offset="1">
																			<el-date-picker
																				style="margin-top: 10px; width: 95%"
																				v-model="item.datetime_input"
																				type="datetime"
																				placeholder="Select Date & Time"
																				class="date"
																				format="yyyy-MM-dd HH:mm"
																				value-format="yyyy-MM-dd HH:mm"
																			>
																			</el-date-picker>
																		</el-col>
																		<el-col
																			v-if="item.marked_as_na == false"
																			:span="2"
																			:offset="1"
																		>
																			<div
																				@click="clear_selection(item, idx)"
																				style="
																					width: 65px;
																					height: 40px;
																					text-align: center;
																					color: #d26300;
																					border: none;
																					cursor: pointer;
																				"
																			>
																				<div style="padding-top: 10px">
																					Clear
																				</div>
																			</div>
																		</el-col>
																	</el-row>

																	<el-row
																		v-if="
																			item.form_question_info.input_type_info
																				.name === 'Timer'
																		"
																		style="margin-top: 10px"
																	>
																		<el-col :span="15" :offset="1">
																			<div
																				v-for="(attempt, attemptIndex) in item
																					.form_question_info.timer_attempts"
																				:key="attemptIndex"
																				class="stopwatch-container"
																			>
																				<div class="time-index">
																					Time {{ attemptIndex + 1 }}
																				</div>
																				<span
																					v-if="
																						item.form_question_info
																							.stopwatches &&
																						item.form_question_info.stopwatches[
																							attemptIndex
																						]
																					"
																					class="stopwatch"
																				>
																					{{
																						formatTime(
																							item.form_question_info
																								.stopwatches[attemptIndex].time
																						).formattedTime
																					}}
																				</span>

																				<el-button
																					class="button-class-white2"
																					size="mini"
																					style="
																						border: none;
																						margin: 0px;
																						height: 30px;
																					"
																					:disabled="
																						shouldDisableStart(
																							idx,
																							attemptIndex,
																							item.form_question_info
																						)
																					"
																					@click="
																						startStopwatch(
																							idx,
																							attemptIndex,
																							item.form_question_info
																						)
																					"
																					v-if="
																						item.form_question_info
																							.showStartButton[attemptIndex]
																					"
																				>
																					Start
																				</el-button>
																				<el-button
																					class="button-class-white2"
																					size="mini"
																					style="
																						border: none;
																						margin: 0px;
																						height: 30px;
																					"
																					@click="
																						stopStopwatch(
																							idx,
																							attemptIndex,
																							item.form_question_info
																						)
																					"
																					v-if="
																						item.form_question_info
																							.showStopButton[attemptIndex]
																					"
																				>
																					Stop
																				</el-button>
																				<el-button
																					class="button-class-white2"
																					size="mini"
																					style="
																						border: none;
																						margin: 0px;
																						height: 30px;
																					"
																					@click="
																						resetStopwatch(
																							idx,
																							attemptIndex,
																							item.form_question_info
																						)
																					"
																					v-if="
																						item.form_question_info
																							.showResetButton[attemptIndex]
																					"
																				>
																					Reset
																				</el-button>
																			</div>
																		</el-col>
																		<el-col
																			v-if="item.marked_as_na == false"
																			:span="2"
																			:offset="1"
																		>
																			<div
																				@click="clear_selection(item, idx)"
																				style="
																					width: 65px;
																					height: 40px;
																					text-align: center;
																					color: #d26300;
																					border: none;
																					cursor: pointer;
																				"
																			>
																				<div style="padding-top: 10px">
																					Clear
																				</div>
																			</div>
																		</el-col>
																	</el-row>
																	<el-row
																		v-if="
																			item.form_question_info.input_type_info
																				.name === 'Timer'
																		"
																		style="margin-top: 10px"
																	>
																		<el-col :span="24" :offset="1">
																			<div class="stopwatch-container">
																				<div class="time-index">
																					Total Time:
																				</div>
																				<div
																					class="stopwatch"
																					style="margin-left: 72px"
																				>
																					<strong>{{
																						totalTime(item.form_question_info)
																					}}</strong>
																				</div>
																			</div>
																			<div class="stopwatch-container">
																				<div class="time-index">
																					Average Time:
																				</div>
																				<div
																					class="stopwatch"
																					style="margin-left: 52px"
																				>
																					<strong>{{
																						averageTime(item.form_question_info)
																					}}</strong>
																				</div>
																			</div>
																		</el-col>
																	</el-row>

																	<el-row
																		style="
																			margin-top: 20px;
																			margin-bottom: 20px;
																		"
																		v-if="
																			item.form_question_info.input_type_info
																				.name == 'Rating'
																		"
																	>
																		<el-col :span="3" :offset="1">
																			<el-select
																				class="select"
																				v-model="item.form_question_info.rating"
																				:disabled="item.marked_as_na"
																				@change="update_rating"
																			>
																				<el-option
																					v-for="(
																						item_r, key_r
																					) in item.rating_list"
																					:key="key_r"
																					:label="item_r.label"
																					:value="item_r.value"
																				>
																				</el-option>
																			</el-select>
																		</el-col>
																		<!-- <el-col :span="1" :offset="1">
																		<div>
																			{{
																				item.form_question_info.minimum_value
																			}}
																		</div>
																	</el-col> -->
																		<el-col :span="18" :offset="1">
																			<el-slider
																				style="color: red"
																				@change="update_rating"
																				:disabled="item.marked_as_na"
																				v-model="item.form_question_info.rating"
																				:min="
																					item.form_question_info.minimum_value
																				"
																				:max="
																					item.form_question_info.maximum_value
																				"
																				show-stops
																			>
																			</el-slider>
																		</el-col>
																		<!-- <el-col :span="1" :offset="1">
																		<div>
																			{{
																				item.form_question_info.maximum_value
																			}}
																		</div>
																	</el-col> -->
																		<el-col
																			v-if="item.marked_as_na == false"
																			:span="2"
																			:offset="0"
																		>
																			<div
																				@click="clear_selection(item, idx)"
																				style="
																					width: 65px;
																					height: 40px;
																					text-align: center;
																					color: #d26300;
																					border: none;
																					cursor: pointer;
																				"
																			>
																				<div style="padding-top: 10px">
																					Clear
																				</div>
																			</div>
																		</el-col>
																	</el-row>
																	<el-row
																		v-if="
																			item.form_question_info.input_type_info
																				.name == 'Phone Number'
																		"
																	>
																		<el-col :span="4" :offset="1">
																			<input
																				type="number"
																				pattern="/^-?\d+\.?\d*$/"
																				onKeyPress="if(this.value.length==10) return false;"
																				v-model="item.phone_number"
																				placeholder="Enter Phone Number"
																				class="input-class-dialog mt-2"
																				style="width: 300px"
																			/>
																		</el-col>
																	</el-row>
																	<el-row
																		v-if="
																			item.form_question_info.input_type_info
																				.name == 'Email'
																		"
																	>
																		<el-col :span="4" :offset="1">
																			<input
																				v-model="item.email"
																				type="email"
																				id="email"
																				name="email"
																				class="input-class-dialog mt-2"
																				style="width: 300px"
																				placeholder="example@example.com"
																			/>
																		</el-col>
																	</el-row>

																	<!-- types close -->
																	<el-row style="margin-top: 10px">
																		<el-col :span="1" :offset="10">
																			<img
																				@click="image_upload(item.id)"
																				width="25px"
																				src="../../../../assets/icons/Camera.png"
																				style="
																					margin-left: 0px;
																					cursor: pointer;
																				"
																			/>
																		</el-col>
																		<el-col style="margin-top: 0px" :span="2">
																			<span
																				@click="image_upload(item.id)"
																				style="
																					margin-left: 0px;
																					cursor: pointer;
																				"
																				>Image
																				<span
																					style="color: red"
																					v-if="
																						item.form_question_info
																							.is_image_required
																					"
																					>*</span
																				>
																			</span>
																		</el-col>
																		<!-- <span>
																		{{ item.id }}
																	</span> -->
																		<input
																			multiple
																			:maxlength="5"
																			type="file"
																			@change.prevent="
																				upload_file_handler($event, item)
																			"
																			:id="'fileUploadSelector' + item.id"
																			style="display: none"
																		/>
																		<el-col style="margin-left: 10px" :span="1">
																			<img
																				@click="show_comment(item)"
																				width="25px"
																				src="../../../../assets/icons/Comment1.png"
																				style="
																					margin-left: 0px;
																					cursor: pointer;
																				"
																			/>
																		</el-col>
																		<el-col style="margin-top: 0px" :span="2">
																			<span
																				@click="show_comment(item)"
																				style="
																					margin-left: 0px;
																					cursor: pointer;
																				"
																				>Comment
																				<span
																					style="color: red"
																					v-if="
																						item.form_question_info
																							.is_comment_required
																					"
																					>*</span
																				></span
																			>
																		</el-col>
																		<el-col
																			style="margin-left: 40px; margin-top: 0px"
																			:span="1"
																			v-if="
																				project_info_object.execution_setup_info
																					.manual_actions_applicable
																			"
																		>
																			<img
																				style="cursor: pointer"
																				@click="raise_ticket(item)"
																				width="25px"
																				src="../../../../assets/icons/ComputerSupport1.png"
																			/>
																		</el-col>
																		<el-col
																			v-if="
																				project_info_object.execution_setup_info
																					.manual_actions_applicable
																			"
																			style="margin-left: 0px; margin-top: 0px"
																			:span="3"
																		>
																			<div
																				style="cursor: pointer"
																				@click="raise_ticket(item)"
																			>
																				Raise Action
																			</div>
																		</el-col>

																		<el-col
																			style="margin-top: 0px"
																			:style="
																				project_info_object.execution_setup_info
																					.manual_actions_applicable == false
																					? 'margin-left: 30px;'
																					: 'margin-left: 0px; '
																			"
																			:span="1"
																		>
																			<span>NA</span>
																		</el-col>
																		<el-col
																			style="margin-left: 0px; margin-top: 2px"
																			:span="1"
																		>
																			<el-switch
																				@change="
																					get_marked_as_na_values(
																						item,
																						item.marked_as_na
																					)
																				"
																				v-model="item.marked_as_na"
																				active-color="#41BE62"
																			>
																			</el-switch>
																		</el-col>
																	</el-row>
																	<el-row
																		v-if="item.show_comment"
																		style="margin-top: 10px"
																	>
																		<el-col :span="23" :offset="1">
																			<el-input
																				type="textarea"
																				:rows="2"
																				placeholder="Enter Comment"
																				v-model="item.comment"
																				class="input-class"
																				:minlength="0"
																			:maxlength="350"
																			/>
																		</el-col>
																	</el-row>
																	<el-row
																		v-if="item.show_comment"
																		style="margin-top: 0px"
																	>
																		<el-col :span="3" :offset="21">
																			<div
																				@click="hide_comment(item)"
																				style="
																					height: 40px;
																					text-align: center;
																					border-radius: 12px;
																					border-color: #d26300;
																					color: #d26300;
																					cursor: pointer;
																				"
																			>
																				<div style="padding-top: 10px">
																					Hide Comment
																				</div>
																			</div>
																		</el-col>
																	</el-row>
																	<div
																		v-if="
																			item.image_conatined &&
																			item.show_image == false
																		"
																	>
																		<!-- @load="
																			get_attachments(item.fileURLArray, item)
																		" -->
																		<div
																			ref="attachmentContainer"
																			style="
																				color: #f9a168;
																				font-size: 13px;
																				cursor: pointer;
																			"
																		>
																			<!-- <b><u>View Images</u></b> -->
																		</div>
																	</div>
																	<div>
																		<el-row style="margin-top: 10px">
																			<el-col
																				style="margin-right: 20px"
																				v-for="(
																					itemz, idxz
																				) in item.fileURLArray"
																				:key="idxz"
																				:span="4"
																				:offset="1"
																			>
																				<div
																					v-if="
																						/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(
																							itemz.file_name
																						)
																					"
																					style="cursor: pointer"
																				>
																					<el-tooltip
																						class="item"
																						effect="light"
																						content="Click to show image"
																						placement="bottom"
																					>
																						<div class="image-container">
																							<img
																								@click="show_excel(itemz.src)"
																								class="uploaded-image"
																								:src="itemz.src"
																								alt="Image Preview"
																								id="preview-img"
																							/>
																						</div>
																					</el-tooltip>
																					<el-tooltip
																						class="item"
																						effect="light"
																						content="Click to show Video Preview"
																						placement="bottom"
																						v-if="
																							/\.(mp4|mov|wmv|avi|avchd|flv|f4v|swf|mkv|webm|mpg|mp2|mpeg|mpe|mpv|video)$/i.test(
																								itemz.file_name
																							)
																						"
																					>
																						<video
																							@click="show_excel(itemz.src)"
																							:src="itemz.src"
																							controls
																							id="preview-video"
																							style="
																								width: 100%;
																								height: 500px;
																								object-fit: cover;
																							"
																						></video>
																					</el-tooltip>
																					<el-tooltip
																						class="item"
																						effect="light"
																						content="Click to show Excel Preview"
																						placement="bottom"
																						v-if="
																							/\.(csv|sheet)$/i.test(
																								itemz.file_name
																							)
																						"
																					>
																						<img
																							@click="show_excel(itemz.src)"
																							src="../../../../assets/icons/excel.png"
																							style="
																								width: 400px;
																								height: 480px;
																								object-fit: cover;
																							"
																						/>
																					</el-tooltip>

																					<el-tooltip
																						class="item"
																						effect="light"
																						content="Click to show Excel Preview"
																						placement="bottom"
																						v-if="
																							/\.(pdf)$/i.test(itemz.file_name)
																						"
																					>
																						<PDFViewer
																							ref="pdfViewer"
																							:source="itemz.src"
																							style="width: 100%; height: 500px"
																							:key="'pdf_' + index"
																							:rendering-text="renderingText"
																							@rendered="onPDFRendered(index)"
																							@download="handleDownload"
																						/>
																					</el-tooltip>
																					<!-- <el-tooltip
																					v-if="
																						itemz.fileDetails.type ==
																						'application/pdf'
																					"
																					class="item"
																					effect="light"
																					content="Click to show pdf"
																					placement="bottom"
																				>
																					<img
																						style="height: 50px"
																						@click="show_excel(itemz.src)"
																						src="../../../../assets/icons/pdf.png"
																					/>
																				</el-tooltip>
																				<el-tooltip
																					v-if="
																						itemz.fileDetails.type.includes(
																							'csv'
																						) ||
																						itemz.fileDetails.type.includes(
																							'sheet'
																						)
																					"
																					class="item"
																					effect="light"
																					content="Click to show excel"
																					placement="bottom"
																				>
																					<img
																						style="height: 50px"
																						@click="show_excel(itemz.src)"
																						src="../../../../assets/icons/excel.png"
																					/>
																				</el-tooltip> -->
																					<!-- <div class="text-right">
																					<i
																						@click="delete_image(itemz, item)"
																						class="el-icon-delete"
																					/>
																				</div> -->
																					<div>
																						<el-row>
																							<el-col :span="22">
																								<span style="font-size: 11px">{{
																									itemz.created_at
																								}}</span>
																							</el-col>
																							<el-col :span="2">
																								<div class="text-right">
																									<i
																										style="cursor: pointer"
																										
																						@click="delete_image(itemz, item,idxS)"
																										class="el-icon-delete"
																									/>
																								</div>
																							</el-col>
																						</el-row>
																					</div>
																				</div>
																			</el-col>
																		</el-row>
																	</div>
																	<div
																		v-if="item.show_image"
																		@click="
																			hide_attachments(item.fileURLArray, item)
																		"
																		style="
																			color: #f9a168;
																			font-size: 13px;
																			cursor: pointer;
																		"
																	>
																		<b><u>Hide Images</u></b>
																	</div>
																	<!-- Dependent Question Start -->
																	<el-row
																		style="margin-top: 10px"
																		v-if="
																			item.child_form_question_execution_list
																				.length != 0
																		"
																	>
																		<el-col :span="22" :offset="1">
																			<el-row
																				v-if="
																					item.form_question_info.expanded ==
																					true
																				"
																			>
																				<el-col class="mt-2" :span="1">
																					<img
																						width="25px"
																						src="../../../../assets/icons/Link.png"
																					/>
																				</el-col>
																				<el-col :span="23">
																					<el-card
																						style="
																							border: 1px dashed;
																							border-color: #f9a168;
																							border-radius: 12px;
																							background-color: #fff9f4;
																						"
																					>
																						<el-row style="cursor: pointer">
																							<el-col
																								v-if="
																									item
																										.child_form_question_execution_list[0]
																										.form_question_info
																										.input_type_info.name ==
																									'Checklist'
																								"
																								:span="1"
																							>
																								<input
																									type="checkbox"
																									style="
																										width: 17px;
																										height: 17px;
																									"
																								/>
																							</el-col>
																							<el-col
																								:style="
																									item
																										.child_form_question_execution_list[0]
																										.form_question_info
																										.input_type_info.name ==
																									'Checklist'
																										? 'margin-top: -2px; margin-left:-20px'
																										: ''
																								"
																								:span="
																									item
																										.child_form_question_execution_list[0]
																										.form_question_info
																										.input_type_info.name ==
																									'Checklist'
																										? 22
																										: 23
																								"
																							>
																								<div
																									@click="collapse_item(item)"
																									style="margin-top: -10px"
																								>
																									{{
																										item
																											.child_form_question_execution_list[0]
																											.form_question_info
																											.input_type_info.name
																									}}
																								</div>
																							</el-col>
																							<el-col :span="1">
																								<el-button
																									@click="collapse_item(item)"
																									icon="el-icon-arrow-down"
																									style="
																										border: none;
																										color: black;
																										font-size: 12px;
																										margin-top: -30px;
																										background-color: #fff9f4;
																									"
																									plain
																								>
																								</el-button>
																							</el-col>
																						</el-row>

																						<el-row
																							style="margin-top: 30px"
																							v-if="
																								item
																									.child_form_question_execution_list[0]
																									.form_question_info
																									.input_type_info.name ==
																								'Yes / No'
																							"
																						>
																							<el-col :span="6">
																								<el-button
																									class="button-class-white-dialog"
																								>
																									Yes
																								</el-button>
																								<el-button
																									class="button-class-white-dialog"
																								>
																									No
																								</el-button>
																							</el-col>
																						</el-row>
																						<el-row
																							v-if="
																								item
																									.child_form_question_execution_list[0]
																									.form_question_info
																									.input_type_info.name ==
																								'Long text'
																							"
																						>
																							<el-col :span="23" :offset="1">
																								<textarea
																									rows="3"
																									type="text"
																									v-model="
																										item.long_description
																									"
																									placeholder="Enter Long description"
																									class="input-class-dialog-textarea mt-2"
																									style="margin-left: -10px"
																								/>
																							</el-col>
																						</el-row>
																						<el-row
																							v-if="
																								item
																									.child_form_question_execution_list[0]
																									.form_question_info
																									.input_type_info.name ==
																								'Short text'
																							"
																						>
																							<el-col :span="10" :offset="1">
																								<input
																									type="text"
																									v-model="
																										item.short_description
																									"
																									placeholder="Enter Short Description"
																									class="input-class-dialog mt-2"
																									style="margin-left: -10px"
																								/>
																							</el-col>
																						</el-row>
																						<el-row
																							v-if="
																								item
																									.child_form_question_execution_list[0]
																									.form_question_info
																									.input_type_info.name ==
																								'Number input'
																							"
																						>
																							<el-col :span="4">
																								<input
																									type="number"
																									v-model="
																										item.dependent_number
																									"
																									placeholder="Enter Number"
																									class="input-class-dialog mt-2"
																									style="width: 600px"
																								/>
																							</el-col>
																						</el-row>
																						<el-row
																							v-if="
																								item
																									.child_form_question_execution_list[0]
																									.form_question_info
																									.input_type_info.name ==
																								'Temperature'
																							"
																						>
																							<el-col
																								style="margin-top: 17px"
																								:span="2"
																							>
																								<span>Test Value</span>
																							</el-col>
																							<el-col :span="3">
																								<span>
																									<input
																										type="number"
																										v-model="
																											item.dependent_test_value
																										"
																										placeholder="Enter Temperature"
																										class="input-class-dialog mt-2"
																										style="width: 200px"
																									/>
																								</span>
																							</el-col>
																							<el-col
																								style="margin-top: 17px"
																								:span="3"
																								:offset="3"
																							>
																								<span>Retest Value</span>
																							</el-col>
																							<el-col :span="1">
																								<span>
																									<input
																										type="number"
																										v-model="
																											item.dependent_retest_value
																										"
																										placeholder="Enter Temperature"
																										class="input-class-dialog mt-2"
																										style="
																											width: 200px;
																											margin-left: -30px;
																										"
																									/>
																								</span>
																							</el-col>
																						</el-row>
																						<el-row
																							v-if="
																								item
																									.child_form_question_execution_list[0]
																									.form_question_info
																									.input_type_info.name == 'TPM'
																							"
																						>
																							<el-col
																								style="margin-top: 17px"
																								:span="2"
																							>
																								<span>Test Value</span>
																							</el-col>
																							<el-col :span="3">
																								<span>
																									<input
																										type="number"
																										v-model="
																											item.dependent_test_value_tpm
																										"
																										placeholder="Enter TPM"
																										class="input-class-dialog mt-2"
																										style="
																											width: 200px;
																											margin-left: 0px;
																										"
																									/>
																								</span>
																							</el-col>
																							<el-col
																								style="margin-top: 17px"
																								:span="3"
																								:offset="3"
																							>
																								<span>Retest Value</span>
																							</el-col>
																							<el-col :span="1">
																								<span>
																									<input
																										type="number"
																										v-model="
																											item.dependent_retest_value_tpm
																										"
																										placeholder="Enter TPM"
																										class="input-class-dialog mt-2"
																										style="
																											width: 200px;
																											margin-left: -30px;
																										"
																									/>
																								</span>
																							</el-col>
																						</el-row>
																						<el-row
																							v-if="
																								item
																									.child_form_question_execution_list[0]
																									.form_question_info
																									.input_type_info.name ==
																								'Select any one'
																							"
																						>
																							<el-row
																								v-for="(obj, key) in item
																									.child_form_questions_list[0]
																									.input_options_list"
																								:key="key"
																								class="mb-3 mt-3"
																							>
																								<el-col :span="4" :offset="1">
																									<el-radio-group>
																										<el-radio
																											:label="obj.name"
																											>{{ obj.name }}</el-radio
																										>
																									</el-radio-group>
																								</el-col>
																								<el-col :span="3">
																									<span style="font-size: 12px">
																										<b
																											>Points -
																											{{ obj.value }}</b
																										>
																									</span>
																								</el-col>
																							</el-row>
																						</el-row>
																						<el-row
																							v-if="
																								item
																									.child_form_question_execution_list[0]
																									.form_question_info
																									.input_type_info.name ==
																								'Multiselect'
																							"
																						>
																							<el-row
																								class="mt-3 mb-3"
																								v-for="(obj, key) in item
																									.child_form_questions_list[0]
																									.input_options_list"
																								:key="key"
																							>
																								<el-col :span="1" :offset="1">
																									<input
																										type="checkbox"
																										style="
																											width: 17px;
																											height: 17px;
																										"
																									/>
																								</el-col>
																								<el-col :span="4">
																									<div
																										style="
																											margin-top: -3px;
																											margin-left: -15px;
																										"
																									>
																										{{ obj.name }}
																									</div>
																								</el-col>
																								<el-col :span="6">
																									<div
																										style="
																											margin-top: 0px;
																											font-size: 12px;
																										"
																									>
																										<b
																											>Points -
																											{{ obj.value }}</b
																										>
																									</div>
																								</el-col>
																							</el-row>
																						</el-row>
																						<el-row
																							style="margin-top: 10px"
																							v-if="
																								item
																									.child_form_question_execution_list[0]
																									.form_question_info
																									.input_type_info.name ==
																								'Datetime'
																							"
																						>
																							<el-col :span="7" :offset="1">
																								<el-date-picker
																									style="
																										margin-top: 10px;
																										width: 95%;
																									"
																									v-model="
																										item.dependent_datetime_input
																									"
																									type="datetime"
																									placeholder="Select Date & Time"
																									class="date"
																									format="yyyy-MM-dd HH:mm:ss"
																								>
																								</el-date-picker>
																							</el-col>
																						</el-row>
																						<el-row
																							style="margin-top: 10px"
																							v-if="
																								item
																									.child_form_question_execution_list[0]
																									.form_question_info
																									.input_type_info.name ==
																								'Date'
																							"
																						>
																							<el-col :span="4">
																								<el-date-picker
																									v-model="item.dependent_date"
																									type="date"
																									placeholder="Select Date"
																									default-value="2010-10-01"
																								>
																								</el-date-picker>
																							</el-col>
																						</el-row>
																						<el-row
																							style="margin-top: 10px"
																							v-if="
																								item
																									.child_form_question_execution_list[0]
																									.form_question_info
																									.input_type_info.name ==
																								'Date and Time'
																							"
																						>
																							<el-col :span="4">
																								<el-date-picker
																									v-model="item.dependent_date"
																									type="date"
																									placeholder="Select Date"
																									default-value="2010-10-01"
																								>
																								</el-date-picker>
																							</el-col>
																							<el-col :span="2" :offset="1">
																								<el-time-select
																									v-model="item.dependent_time"
																									:picker-options="{
																										start: '00:00',
																										step: '00:30',
																										end: '23:45',
																									}"
																									placeholder="Select time"
																								>
																								</el-time-select>
																							</el-col>
																						</el-row>
																						<el-row
																							v-if="
																								item
																									.child_form_question_execution_list[0]
																									.form_question_info
																									.input_type_info.name ==
																								'Rating'
																							"
																						>
																							<el-col :span="1">
																								<div style="margin-top: 10px">
																									{{
																										item.form_question_info
																											.child_form_questions_list[0]
																											.minimum_value
																									}}
																								</div>
																							</el-col>
																							<el-col :span="16">
																								<span>
																									<el-slider
																										v-model="
																											item.dependent_rating
																										"
																										:min="
																											item.form_question_info
																												.child_form_questions_list[0]
																												.minimum_value
																										"
																										:max="
																											item.form_question_info
																												.child_form_questions_list[0]
																												.maximum_value
																										"
																										show-stops
																									>
																									</el-slider>
																								</span>
																							</el-col>
																							<el-col :span="1" :offset="1">
																								<div
																									style="
																										margin-top: 10px;
																										margin-left: -20px;
																									"
																								>
																									{{
																										item.form_question_info
																											.child_form_questions_list[0]
																											.maximum_value
																									}}
																								</div>
																							</el-col>
																						</el-row>
																						<el-row
																							v-if="
																								item
																									.child_form_question_execution_list[0]
																									.form_question_info
																									.input_type_info.name ==
																								'Phone Number'
																							"
																						>
																							<el-col :span="4">
																								<input
																									type="number"
																									pattern="/^-?\d+\.?\d*$/"
																									onKeyPress="if(this.value.length==10) return false;"
																									v-model="
																										item.dependent_phone_number
																									"
																									placeholder="Enter Phone Number"
																									class="input-class-dialog mt-2"
																									style="width: 300px"
																								/>
																							</el-col>
																						</el-row>
																						<el-row
																							v-if="
																								item
																									.child_form_question_execution_list[0]
																									.form_question_info
																									.input_type_info.name ==
																								'Email'
																							"
																						>
																							<el-col :span="4">
																								<input
																									v-model="item.dependent_email"
																									type="email"
																									id="email"
																									name="email"
																									class="input-class-dialog mt-2"
																									style="width: 300px"
																									placeholder="example@example.com"
																								/>
																							</el-col>
																						</el-row>
																						<el-row style="margin-top: 10px">
																							<el-col :span="1" :offset="13">
																								<img
																									width="25px"
																									src="../../../../assets/icons/Camera.png"
																								/>
																							</el-col>
																							<el-col
																								style="margin-top: 0px"
																								:span="1"
																							>
																								<span style="margin-left: -3px"
																									>Image
																								</span>
																							</el-col>
																							<el-col
																								style="margin-left: 10px"
																								:span="1"
																							>
																								<img
																									width="25px"
																									src="../../../../assets/icons/Comment1.png"
																								/>
																							</el-col>
																							<el-col
																								style="margin-top: 0px"
																								:span="1"
																							>
																								<span style="margin-left: -3px"
																									>Comment</span
																								>
																							</el-col>
																							<el-col
																								style="
																									margin-left: 40px;
																									margin-top: 0px;
																								"
																								:span="1"
																							>
																								<img
																									width="25px"
																									src="../../../../assets/icons/ComputerSupport1.png"
																								/>
																							</el-col>
																							<el-col
																								style="
																									margin-left: -3px;
																									margin-top: 0px;
																								"
																								:span="3"
																							>
																								<span>Raise Action </span>
																							</el-col>
																							<el-col
																								style="
																									margin-left: -20px;
																									margin-top: 0px;
																								"
																								:span="1"
																							>
																								<span>NA</span>
																							</el-col>
																							<el-col
																								style="
																									margin-left: -10px;
																									margin-top: 2px;
																								"
																								:span="1"
																							>
																								<el-switch
																									active-color="#41BE62"
																								>
																								</el-switch>
																							</el-col>
																						</el-row>
																					</el-card>
																				</el-col>
																			</el-row>
																			<div
																				v-if="
																					item.form_question_info.expanded ==
																					false
																				"
																			>
																				<el-row>
																					<el-col class="mt-2" :span="1">
																						<img
																							width="25px"
																							src="../../../../assets/icons/Link.png"
																						/>
																					</el-col>
																					<el-col :span="23">
																						<el-card
																							style="
																								border: 1px dashed;
																								border-color: #f9a168;
																								height: 60px;
																								border-radius: 12px;
																								background-color: #fff9f4;
																							"
																						>
																							<el-row style="cursor: pointer">
																								<el-col
																									v-if="
																										item
																											.child_form_question_execution_list[0]
																											.form_question_info
																											.input_type_info.name ==
																										'Checklist'
																									"
																									:span="1"
																								>
																									<input
																										type="checkbox"
																										style="
																											width: 17px;
																											height: 17px;
																										"
																									/>
																								</el-col>
																								<el-col
																									:span="
																										item
																											.child_form_question_execution_list[0]
																											.form_question_info
																											.input_type_info.name ==
																										'Checklist'
																											? 22
																											: 23
																									"
																								>
																									<div
																										@click="expand_item(item)"
																										style="margin-top: -10px"
																									>
																										{{
																											item
																												.child_form_question_execution_list[0]
																												.form_question_info
																												.input_type_info.name
																										}}
																									</div>
																								</el-col>
																								<el-col :span="1">
																									<el-button
																										@click="expand_item(item)"
																										icon="el-icon-arrow-right"
																										style="
																											border: none;
																											color: black;
																											font-size: 12px;
																											margin-top: -30px;
																											background-color: #fff9f4;
																										"
																										plain
																									>
																									</el-button>
																								</el-col>
																							</el-row>
																						</el-card>
																					</el-col>
																				</el-row>
																			</div>
																		</el-col>
																	</el-row>
																	<!-- Dependent Question End -->
																</el-card>
															</div>
														</el-col>
													</el-row>
												</el-col>
											</el-row>
										</div>
									</el-col>
								</el-row>
							</div>
						</el-col>
					</el-row>
				</div>
			</el-col>
		</el-row>
			<el-row>
			<el-col :span="15" :offset="5">
				<el-card style="margin-top: 0px" shadow="none">
					<el-row>
						<el-col style="margin-top: 0px" :span="3" :offset="14">
							<el-button
								:disabled="current_question_idx == 0"
								@click="prev_question()"
								class="button-class-new"
								icon="el-icon-caret-left"
								:loading="calling_api"
							>
								Back
							</el-button>
						</el-col>
						<!-- 
							v-if="get_company_condition"
						 -->
						<el-col
							style="margin-left: 10px"
							:span="3"
							:offset="1"
						>
							<el-button
								:loading="calling_api"
								class="button-class-white2-new"
								style="margin-top: 1px;"
								:style="'width:100%'"
								@click="save_n_exit('Section')"
							>
								Save & Exit
							</el-button>
						</el-col>
						<el-col
							style="margin-left: 30px; margin-top: 0px"
							:span="3"
							:offset="1"
						>
							<el-button
								:disabled="
									tableDataActiveSectionAbout.length - 1 == current_question_idx
								"
								@click="next_question()"
								class="button-class-new"
								icon="el-icon-caret-right"
								:loading="calling_api"
							>
								Next
							</el-button>
						</el-col>
					</el-row>
				</el-card>
			</el-col>
		</el-row>
		<ViewQuestionImagesVue
			:imagesArray="imagesArray"
			:viewQuestionImagesDialog="viewQuestionImagesDialog"
			@close="viewQuestionImagesDialog = false"
			@clicked="getAppropriateResponse"
		/>
	</div>
</template>

<script>
import formBuilderServices from "../../../../services/formBuilderServices";
import ViewQuestionImagesVue from "../ViewQuestionImagesQ.vue";
export default {
	props: {
		preview_formItemArray: Array,
		formDetails: Object,
		current_obj: Object,
		description: String,
		current_question_idx: Number,
		showing_index: Boolean,
		tableDataActiveSectionAbout: Array,
		Question_form_Details: Object,
		current_category_item: Object,
		current_category_index: Number,
		tableDataActiveCategory: Array,
		project_info_object: Object,
	},
	components: { ViewQuestionImagesVue },
	data: () => ({
		all_pass_current_question_points: [],
		new_formItemArray: [],
		current_obj_obj: {},
		total_points: 0,
		current_points: 0,
		current_question_points: 0,
		viewQuestionImagesDialog: false,
		imagesArray: [],
		viewQuestionImagesDialog: false,
		isloading: false,
		green_color: "",
		red_color: "",
		show_mark_all_na: false,
		stopwatches: [], // Array to store stopwatch times in milliseconds
		isRunning: [],
		interval: [],
		showStartButton: [],
		showStopButton: [],
		showResetButton: [],
		stopwatches: [],
		isRunning: [],
		interval: [],
		showStartButton: [],
		showStopButton: [],
		showResetButton: [],
		nextIndex: null,
		localData:{}

	}),
	async created() {
		this.localData = localStorage.getItem("check_company");
		this.localData = JSON.parse(this.localData);
		this.isloading = true;
		this.get_on_load_data();
	},
	watch: {
		showing_index(val) {
			if (val) {
				this.current_question_points = 0;
				this.total_points = 0;
				this.isloading = true;
				this.get_on_load_data();
			}
		},
	},
	computed: {
		get_company_condition(){
			if(this.localData && this.localData.is_bt) if(this.tableDataActiveSectionAbout.length - 1 == this.current_question_idx) return true
			else return false
		}
	},
	mounted() {},
	methods: {
		async handleDownload(pdfInfo) {
			try {
				const response = await fetch(pdfInfo.src);
				if (!response.ok) {
					throw new Error("Network response was not ok");
				}
				const pdfData = await response.blob();
				const link = document.createElement("a");
				link.href = window.URL.createObjectURL(pdfData);
				link.download = pdfInfo.filename;
				link.click();
				window.URL.revokeObjectURL(link.href);
			} catch (error) {
				console.error("Error downloading PDF:", error.message);
			}
		},
		onPDFRendered(index, src) {
			console.log(this.$refs.pdfViewer, "pdfViewer");
			console.log("PDF rendered at index:", index);
			setTimeout(() => {
				this.$nextTick(() => {
					this.$forceUpdate();
				});
			}, 100);
		},
		shouldDisableStart(index, attemptIndex, item) {
			if (attemptIndex === 0 && !item.isRunning[attemptIndex]) {
				return false;
			}
			if (
				attemptIndex > 0 &&
				item.stopwatches[attemptIndex - 1].stopped &&
				!item.isRunning[attemptIndex]
			) {
				return false;
			}
			if (attemptIndex === item.nextIndex && !item.isRunning[attemptIndex]) {
				return false;
			}
			console.log(
				index,
				attemptIndex,
				item,
				item.stopwatches[attemptIndex - 1],
				"item.stopwatches"
			);
			if (item.stopwatches[attemptIndex - 1].id) {
				if (attemptIndex + 1 < item.stopwatches.length) {
					if (!item.isRunning[attemptIndex + 1]) {
						return false;
					}
				}
			}
			return true;
		},
		stopStopwatch(index, attemptIndex, item) {
			this.$set(item.showStartButton, attemptIndex, false);
			this.$set(item.showStopButton, attemptIndex, false);
			this.$set(item.showResetButton, attemptIndex, true);
			item.isRunning[attemptIndex] = false;
			clearInterval(item.interval[attemptIndex]);
			item.nextIndex = attemptIndex + 1;
			while (
				item.nextIndex < item.stopwatches.length &&
				item.stopwatches[item.nextIndex].stopped
			) {
				item.nextIndex++;
			}

			for (let i = 0; i < item.stopwatches.length; i++) {
				item.stopwatches[i].new_time = this.formatTime(
					item.stopwatches[i].time
				);
			}
			this.$forceUpdate();
		},
		startStopwatch(index, attemptIndex, item) {
			console.log(item, "item");
			this.$set(item.showStartButton, attemptIndex, false);
			this.$set(item.showStopButton, attemptIndex, true);
			if (item.stopwatches[attemptIndex].id) {
				// Retain the existing id, time, and serial_no properties
				const { id, time, serial_no } = item.stopwatches[attemptIndex];
				this.$set(item.stopwatches, attemptIndex, { id, time, serial_no });
			} else {
				this.$set(item.stopwatches, attemptIndex, { time: 0 });
			}
			this.$set(item.isRunning, attemptIndex, true);
			item.interval[attemptIndex] = setInterval(() => {
				this.$set(
					item.stopwatches[attemptIndex],
					"time",
					item.stopwatches[attemptIndex].time + 1000
				);
				// Call formatTime for every interval update
				this.formatTime(item.stopwatches[attemptIndex].time, item);
				this.$forceUpdate();
			}, 1000);
		},
		resetStopwatch(index, attemptIndex, item) {
			if (item.stopwatches[attemptIndex].id) {
				let params = {
					timer_ids: [item.stopwatches[attemptIndex].id],
				};
				formBuilderServices.deleteTimer(params).then((res) => {
					console.log(res, "tsg");
				});
			}
			clearInterval(item.interval[attemptIndex]);
			item.isRunning[attemptIndex] = false;
			item.stopwatches[attemptIndex].time = 0;
			this.$set(item.showStartButton, attemptIndex, true);
			this.$set(item.showStopButton, attemptIndex, false);
			this.$set(item.showResetButton, attemptIndex, false);
			item.stopwatches[attemptIndex].new_time = this.formatTime(
				item.stopwatches[attemptIndex].time
			);
			for (let i = attemptIndex + 1; i < item.stopwatches.length; i++) {
				if (!item.stopwatches[attemptIndex].id) {
					this.$set(item.showStartButton, i, true); // Show the start button
					this.$set(item.isRunning, i, false); // Ensure it's not running
					this.$set(item.stopwatches[i], "time", 0); // Reset the time
					this.$set(item.showStartButton, i, true); // Enable the button but disable it
				}
			}
			this.$forceUpdate();
		},
		formatTime(time, item) {
			if (isNaN(time) || time < 0) {
				return {
					formattedTime: "00:00:00",
					item: item,
				};
			}
			if (!time) {
				return {
					formattedTime: "00:00:00",
					item: item,
				};
			}
			if (time == 0) {
				return {
					formattedTime: "00:00:00",
					item: item,
				};
			}
			const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
			const minutes = Math.floor((time / (1000 * 60)) % 60);
			const seconds = Math.floor((time / 1000) % 60);
			const formattedTime = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(
				seconds
			)}`;
			return {
				formattedTime: formattedTime,
				item: item,
			};
		},
		pad(num) {
			return num.toString().padStart(2, "0");
		},
		totalTime(item) {
			let totalMilliseconds = 0;
			item.stopwatches.forEach((stopwatch) => {
				totalMilliseconds += stopwatch.time;
			});
			const totalSeconds = Math.floor(totalMilliseconds / 1000);
			const hours = Math.floor(totalSeconds / 3600);
			const minutes = Math.floor((totalSeconds % 3600) / 60);
			const seconds = totalSeconds % 60;
			return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
		},
		averageTime(item) {
			if (item.stopwatches.length === 0) {
				return "00:00:00";
			}
			const totalMilliseconds = item.stopwatches.reduce(
				(acc, stopwatch) => acc + stopwatch.time,
				0
			);
			const averageMilliseconds = totalMilliseconds / item.stopwatches.length;
			const totalSeconds = Math.floor(averageMilliseconds / 1000);
			const hours = Math.floor(totalSeconds / 3600);
			const minutes = Math.floor((totalSeconds % 3600) / 60);
			const seconds = totalSeconds % 60;
			return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
		},
		show_mark_all_na_method() {
			this.preview_formItemArray.forEach((itemArray) => {
				itemArray.que_list.forEach((item) => {
					console.log(itemArray.que_list);
					item.marked_as_na = this.show_mark_all_na;
				});
			});
			this.$forceUpdate();
		},
		button_condition_yes_to_all() {
			this.current_question_points = 0;
			this.green_color =
				"color:white; background:#41BE62; border-color:#41BE62";
			this.red_color = "";

			this.preview_formItemArray.forEach((itemArray) => {
				itemArray.que_list.forEach((item) => {
					if (item.form_question_info.input_type_info.name == "Yes / No") {
						item.button_yes = true;
						item.boolean_input = true;
						item.button_no = null;
						item.green_color =
							"color:white; background:#41BE62; border-color:#41BE62";
						item.red_color = "";

						if (item.form_question_info.expected_responses_list.length != 0) {
							item.form_question_info.expected_responses_list.forEach(
								(response) => {
									if (response.expected_boolean_value == item.button_yes) {
										item.current_question_points = response.points_on_trigger;
									}
								}
							);
						}

						this.current_question_points +=
							item.current_question_points !== undefined
								? item.current_question_points
								: 0;
					}
				});
			});

			if (this.Question_form_Details.scoring_type == "all_pass") {
				this.all_pass_current_question_points =
					this.Question_form_Details.total_points;
			}
		},
		button_condition_no_to_all() {
			this.current_question_points = 0;
			this.green_color =
				"color:white; background:#41BE62; border-color:#41BE62";
			this.red_color = "";

			this.preview_formItemArray.forEach((itemArray) => {
				itemArray.que_list.forEach((item) => {
					if (item.form_question_info.input_type_info.name == "Yes / No") {
						item.button_yes = null;
						item.boolean_input = true;
						item.button_no = true;
						item.green_color =
							"color:white; background:#41BE62; border-color:#41BE62";
						item.red_color = "";

						if (item.form_question_info.expected_responses_list.length != 0) {
							item.form_question_info.expected_responses_list.forEach(
								(response) => {
									if (response.expected_boolean_value == item.button_no) {
										item.current_question_points = response.points_on_trigger;
									}
								}
							);
						}

						this.current_question_points +=
							item.current_question_points !== undefined
								? item.current_question_points
								: 0;
					}
				});
			});

			if (this.Question_form_Details.scoring_type == "all_pass") {
				this.all_pass_current_question_points =
					this.Question_form_Details.total_points;
			}
		},
		clear_all_selection() {
			this.green_color = "";
			this.red_color = "";

			this.preview_formItemArray.forEach((itemArray) => {
				itemArray.que_list.forEach((item) => {
					switch (item.form_question_info.input_type_info.name) {
						case "Yes / No":
							item.boolean_input = null;
							item.button_no = null;
							item.button_yes = null;
							item.red_color = "";
							item.green_color = "";
							item.current_question_points = 0;
							break;
						case "Checklist":
							item.checked = null;
							break;
						case "Rating":
							item.number_input = null;
							break;
						case "Select any one":
							item.input_option = null;
							item.form_question_info.input_options_list.forEach((option) => {
								option.checked = false;
							});
							break;
						case "Multiselect":
							item.multiple_input_options = [];
							item.form_question_info.input_options_list.forEach((option) => {
								option.selected = false;
							});
							break;
						case "Long text":
						case "Short text":
						case "Number input":
							item.text_input = null;
							item.number_input = null;
							break;
						case "Temperature":
						case "TPM":
							item.number_input = null;
							item.repeat_number_input = null;
							item.test_color = null;
							item.test_color_retest = null;
							item.show_temp_retest = false;
							item.test_color_tpm = null;
							item.test_color_tpm_retest = null;
							item.show_tpm_retest = false;
							break;
						default:
							break;
					}
				});
			});

			this.$forceUpdate();
			return this.preview_formItemArray;
		},
		get_marked_as_na_values(item, val) {
			this.total_points = 0;
			this.current_question_points = 0;

			if (val == true) {
				item.total_points = 0;
				item.current_question_points = 0;

				this.preview_formItemArray.forEach((itemArray) => {
					itemArray.que_list.forEach((question) => {
						this.total_points += question.total_points;
						this.current_question_points +=
							question.current_question_points !== undefined
								? question.current_question_points
								: 0;
					});
				});
			} else {
				item.total_points = item.form_question_info.total_points;
				item.red_color = "";
				item.green_color = "";
				item.boolean_input = null;
				item.button_no = null;
				item.button_yes = null;

				this.preview_formItemArray.forEach((itemArray) => {
					itemArray.que_list.forEach((question) => {
						this.total_points += question.total_points;
						question.current_question_points = 0;
						this.current_question_points +=
							question.current_question_points !== undefined
								? question.current_question_points
								: 0;
					});
				});

				this.green_color = "";
				this.red_color = "";
			}
		},
		update_rating() {
			this.$forceUpdate();
		},
		async get_on_load_data() {
			console.log(this.preview_formItemArray, "this.preview_formItemArray");
			this.preview_formItemArray.forEach((el) => {
				el.que_list.forEach((question) => {
					console.log(
						question.form_question_info.input_type_info,
						"question.form_question_info.input_type_info"
					);
					if (question.form_question_info.input_type_info.name === "Timer") {
						console.log("here");

						let timerAttempts = question.form_question_info.timer_attempts;
						console.log(timerAttempts, "timerAttempts");
						question.form_question_info.stopwatches = [];
						question.form_question_info.isRunning = [];
						question.form_question_info.showStartButton = [];
						question.form_question_info.showResetButton = [];
						question.form_question_info.showStopButton = [];
						question.form_question_info.interval = [];

						const timerDataLength = question.timer_input_data.length;

						for (let k = 0; k < Math.max(timerAttempts, timerDataLength); k++) {
							if (k < timerDataLength) {
								const timerData = question.timer_input_data[k];
								question.form_question_info.stopwatches.push({
									id: timerData.id || null,
									time: timerData.seconds * 1000 || 0,
									serial_no: timerData.serial_no || null,
								});
								question.form_question_info.showResetButton.push(
									!!timerData.id
								);
								question.form_question_info.showStartButton.push(!timerData.id);
							} else {
								question.form_question_info.stopwatches.push({
									time: 0,
									stopped: false,
								});
								question.form_question_info.showResetButton.push(false);
								question.form_question_info.showStartButton.push(true);
							}
							question.form_question_info.showStopButton.push(false);
							question.form_question_info.isRunning.push(false);
							question.form_question_info.interval.push(0);
						}
					}
				});
			});

			this.yes_no_count = 0;
			this.isloading = true;
			this.green_color = "";
			this.red_color = "";

			if (this.description != null) {
				this.preview_formItemArray.forEach((el) => {
					el.que_list.forEach((item) => {
						if (item.id == this.current_obj.id) {
							item.ticket_raised = true;
						}
					});
				});
				this.$forceUpdate();
			}

			this.preview_formItemArray.forEach((el) => {
				el.que_list.forEach((item) => {
					item.filesArray = [];
					item.fileURLArray = [];
					item.filesPreviewArray = [];
					let fileURLArray = [];

					if (item.form_question_execution_attachments.length != 0) {
						item.image_conatined = true;
					}

					item.form_question_execution_attachments.forEach((el) => {
						fileURLArray.push(el);
					});

					item.show_image = false;

					if (fileURLArray.length != 0) {
					 Promise.all(
						fileURLArray.map(async (el) => {
							let params = {
								file_path: el.file_path,
								storage: "task",
							};
							const res = await formBuilderServices.getAttachmentURL(params);
							el.src = JSON.parse(res.data).data;
							el.created_at = moment
								.utc(el.created_at)
								.local()
								.format("Do MMM YY, HH:mm:ss");
							return el;
						})
					).then((updatedFileURLArray) => {
						this.$set(
							this.preview_formItemArray[i],
							"fileURLArray",
							updatedFileURLArray
						);
						// If you need to force an update immediately after setting fileURLArray:
						// this.$forceUpdate();
					});
				}
					this.$forceUpdate();
				});
			});

			this.$forceUpdate();

			this.preview_formItemArray.forEach((el) => {
				el.que_list.forEach((item) => {
						console.log(item,'item,',el)
					if (item.form_question_info.input_type_info.name == "Yes / No") {
						this.yes_no_count += 1;
						this.$forceUpdate();

						if (item.marked_as_na == false) {
							item.total_points = item.form_question_info.total_points;
							this.total_points += item.total_points;
						} else {
							item.total_points = 0;
						}

						if (item.boolean_input != null) {
							item.button_yes = item.boolean_input == true ? true : false;
							item.button_no = item.boolean_input == false ? true : false;

							if (item.button_yes) {
								item.green_color =
									"color:white; background:#41BE62; border-color:#41BE62";
								item.red_color = "";

								if (
									item.form_question_info.expected_responses_list.length != 0
								) {
									item.form_question_info.expected_responses_list.forEach(
										(response) => {
											if (response.expected_boolean_value == item.button_yes) {
												item.current_question_points =
													response.points_on_trigger;
											}
										}
									);
								}
							}
							if (item.button_no) {
								item.red_color =
									"color:white; background:#FF0000; border-color:#FF0000";
								item.green_color = "";

								if (
									item.form_question_info.expected_responses_list.length != 0
								) {
									item.form_question_info.expected_responses_list.forEach(
										(response) => {
											if (response.expected_boolean_value == !item.button_no) {
												item.current_question_points =
													response.points_on_trigger;
											}
										}
									);
								}
							}
						}
						this.current_question_points +=
							item.current_question_points != undefined
								? item.current_question_points
								: 0;
					}

					if (item.form_question_info.input_type_info.name == "Checklist") {
						if (item.boolean_input == true) {
							item.checked = true;
						}
					}

					if (item.form_question_info.input_type_info.name == "Photo") {
						item.form_question_info.is_image_required = true;
					}

					if (item.form_question_info.input_type_info.name == "Rating") {
						item.form_question_info.rating =
							item.number_input == null ? null : item.number_input;
						item.rating_list = [];
						for (
							let r = item.form_question_info.minimum_value;
							r <= item.form_question_info.maximum_value;
							r++
						) {
							item.rating_list.push({
								label: r,
								value: r,
							});
						}
					}

					if (
						item.form_question_info.input_type_info.name == "Select any one"
					) {
						if (item.input_option != null) {
							item.form_question_info.input_options_list.forEach((option) => {
								if (option.id == item.input_option) {
									option.checked = item.input_option;
								}
							});
						}
					}

					if (item.form_question_info.input_type_info.name == "Multiselect") {
						if (item.multiple_input_options.length != 0) {
							item.form_question_info.input_options_list.forEach((option) => {
								item.multiple_input_options.forEach((selectedOption) => {
									if (option.id == selectedOption) {
										option.selected = selectedOption;
									}
								});
							});
						}
					}

					if (item.form_question_info.input_type_info.name == "Temperature") {
						this.get_temperature_content(item, item.number_input);
						this.get_temperature_content_retest(item, item.repeat_number_input);
					}

					if (item.form_question_info.input_type_info.name == "TPM") {
						this.get_tpm_content(item, item.number_input);
						this.get_tpm_content_retest(item, item.repeat_number_input);
					}
				});
			});

			let green = 0;
			let red = 0;

			this.preview_formItemArray.forEach((el) => {
				el.que_list.forEach((item) => {
					if (item.button_yes != true) {
						red += 1;
					}
					if (item.button_no != true) {
						green += 1;
					}
				});
			});

			if (green != 0 && red != 0) {
				this.green_color = "";
				this.red_color = "";
			} else {
				if (green > 0) {
					this.green_color =
						"color:white; background:#41BE62; border-color:#41BE62";
					if (this.Question_form_Details.scoring_type == "all_pass") {
						this.all_pass_current_question_points =
							this.Question_form_Details.total_points;
					}
				}
				if (red > 0) {
					this.red_color =
						"color:white; background:#FF0000; border-color:#FF0000";
				}
			}

			this.$forceUpdate();
			this.isloading = false;
			console.log(this.yes_no_count);
			this.$emit('update_preview_formItemArray1', this.preview_formItemArray)

			return [this.preview_formItemArray, this.yes_no_count];
		},
		hide_attachments(arr, item) {
			item.show_image = false;
			this.$forceUpdate();
			return arr, item;
		},
		get_attachments(arr, item) {
			this.image_array = arr;
			this.current_img_item = item;
			this.isloading = true;

			Promise.all(
				arr.map(async (el) => {
					if (el.file_path) {
						let params = {
							file_path: el.file_path,
							storage: "task",
						};
						try {
							const res = await formBuilderServices.getAttachmentURL(params);
							el.src = JSON.parse(res.data).data;
							el.file_name = el.file_path;
						} catch (error) {
							console.error("Error fetching attachment URL:", error);
						}
					} else {
						if (el.fileDetails && el.fileDetails.name) {
							el.file_name = el.fileDetails.name;
						} else {
							el.file_name = null; // or any other fallback value you prefer
						}
					}
				})
			).then(() => {
				setTimeout(() => {
					this.imagesArray = arr;
					setTimeout(() => {
						this.viewQuestionImagesDialog = true;
						this.isloading = false;
						this.$forceUpdate();
					}, 300);
				}, 300);
			});
			return arr, item;
		},
		get_image(arr) {
			// this.imagesArray = arr;
			// setTimeout(() => {
			// 	this.viewQuestionImagesDialog = true;
			// }, 200);
			// this.$forceUpdate();
			arr.forEach(async (el) => {
				let params = {
					file_path: el.file_path,
					storage: "task",
				};
				await formBuilderServices.getAttachmentURL(params).then((res) => {
					el.src = JSON.parse(res.data).data;
				});
			});
			this.imagesArray = arr;
			setTimeout(() => {
				this.viewQuestionImagesDialog = true;
			}, 200);
			this.$forceUpdate();
		},
		// delete_image(item, idx, idxS) {
		// 	for (
		// 		let i = 0;
		// 		i < this.preview_formItemArray[idxS].que_list.length;
		// 		i++
		// 	) {
		// 		if (item.id == this.preview_formItemArray[idxS].que_list[i].id) {
		// 			this.preview_formItemArray[idxS].que_list[
		// 				i
		// 			].form_question_execution_attachments.splice(idx, 1);
		// 		}
		// 	}
		// 	// item.fileURLArray.splice(idx, 1);
		// 	return item, this.preview_formItemArray;
		// },
		delete_image(item, m_item) {
			console.log(item, "item delete", m_item);
			if (item.id) {
				formBuilderServices.deleteAttachments({ id: item.id }).then((res) => {
					console.log(res, "resp");
				});
			} 
				const indexToRemove = m_item.fileURLArray.findIndex(
					(file) =>
						file.name === item.name
				);
				if (indexToRemove !== -1) {
					// Use Vue.set or splice to update the array in a reactive way
					this.$set(m_item.fileURLArray, indexToRemove, undefined);
					m_item.fileURLArray.splice(indexToRemove, 1);
				}
			console.log(m_item,'m_item')

			this.$notify.success({
				title: "Success",
				message: "Attachment Deleted Successfully",
				type: "success",
			});
			this.$forceUpdate();
			return m_item;
		},
		show_excel(excel) {
			window.open(excel);
		},
		image_upload(id) {
			document.getElementById("fileUploadSelector" + id).click();
			// this.$refs.fileUploadSelector.click();
		},
		// upload_file_handler(event, item) {
		// 	const tempObjIndex = item.que_list.findIndex((el) => el.id == item.id);
		// 	if (item.que_list[tempObjIndex].fileURLArray.length <= 5) {
		// 		if (tempObjIndex !== -1) {
		// 			if (event.target.files && event.target.files.length) {
		// 				item.que_list[tempObjIndex].filesArray = event.target.files;
		// 				let obj = {};
		// 				if (item.que_list[tempObjIndex].filesArray.length <= 5) {
		// 					for (
		// 						let i = 0;
		// 						i < item.que_list[tempObjIndex].filesArray.length;
		// 						i++
		// 					) {
		// 						obj = {
		// 							fileDetails: item.que_list[tempObjIndex].filesArray[i],
		// 							src: URL.createObjectURL(
		// 								item.que_list[tempObjIndex].filesArray[i]
		// 							),
		// 						};
		// 						item.que_list[tempObjIndex].filesPreviewArray.push(obj);
		// 					}
		// 					for (
		// 						let c = 0;
		// 						c < item.que_list[tempObjIndex].filesPreviewArray.length;
		// 						c++
		// 					) {
		// 						item.que_list[tempObjIndex].fileURLArray.push(
		// 							item.que_list[tempObjIndex].filesPreviewArray[c]
		// 						);
		// 					}
		// 					item.que_list[tempObjIndex].show_image = false;
		// 					item.que_list[tempObjIndex].image_conatined = true;
		// 					if (item.que_list[tempObjIndex].fileURLArray.length != 0) {
		// 						const formData = new FormData();
		// 						for (
		// 							let x = 0;
		// 							x < item.que_list[tempObjIndex].filesArray.length;
		// 							x++
		// 						) {
		// 							formData.append(
		// 								"attachments",
		// 								item.que_list[tempObjIndex].filesArray[x]
		// 							);
		// 							formData.append("storage", "task");
		// 						}
		// 						formBuilderServices
		// 							.uploadImageAttachment(formData)
		// 							.then((res) => {
		// 								item.que_list[
		// 									tempObjIndex
		// 								].form_question_execution_attachments = JSON.parse(
		// 									res.data
		// 								).data;
		// 							});
		// 					}
		// 				} else {
		// 					alert("cannot upload more than 5 file");
		// 				}
		// 			}
		// 		}
		// 	} else {
		// 		alert("cannot upload more than 5 file");
		// 	}
		// 	this.$forceUpdate();
		// 	return item, item.que_list;
		// },
		async upload_file_handler(event, item) {
    const tempObjIndex = item.que_list.findIndex((el) => el.id == item.id);

    if (tempObjIndex !== -1) {
        const filesArray = event.target.files;
        let imageCount = item.que_list[tempObjIndex].fileURLArray.length; // Get current image count

        console.log("Starting upload process...");

        // Check if adding new files will exceed the limit
        if (imageCount + filesArray.length > 5) {
            alert("You can upload a maximum of 5 images.");
            return; // Exit function
        }

        for (let i = 0; i < filesArray.length; i++) {
            const file = filesArray[i];

            // Check if the file is an image
            if (file.type.startsWith("image/")) {
                console.log(
                    `Processing image ${i + 1} of ${filesArray.length}: ${file.name}`
                );

                // Check if the file is a duplicate
                const isDuplicate = item.que_list[tempObjIndex].fileURLArray.some(
                    (image) => image === URL.createObjectURL(file)
                );
                if (isDuplicate) {
                    alert("This image is already uploaded.");
                    continue; // Skip this file
                }

                // Check file size
                if (file.size > 500 * 1024) {
                    // 500 KB in bytes
                    // Compress the image
                    const compressedImage = await this.compressImage(file);
                    item.que_list[tempObjIndex].filesArray.push(compressedImage);
                    const compressedSizeKB = Math.round(compressedImage.size / 1024); // Convert bytes to KB
                    console.log(`Compressed file size: ${compressedSizeKB} KB`);

                    console.log(
                        `Image compressed successfully: ${compressedImage.name}`
                    );
                } else {
                    item.que_list[tempObjIndex].filesArray.push(file);
                }

                // Create preview object
                const obj = {
                    fileDetails: file,
                    src: URL.createObjectURL(file), // Generate Blob URL for image preview
                    file_name: file.name,
                };
                item.que_list[tempObjIndex].filesPreviewArray.push(obj);

                // Push image into fileURLArray
                item.que_list[tempObjIndex].fileURLArray.push(obj);
            } else {
                alert("Please upload only image files.");
            }
        }

        // Upload files if new images were added
        if (item.que_list[tempObjIndex].fileURLArray.length > imageCount) {
            const formData = new FormData();
            for (let x = 0; x < item.que_list[tempObjIndex].filesArray.length; x++) {
                formData.append("attachments", item.que_list[tempObjIndex].filesArray[x]);
                formData.append("storage", "task");
            }
            formBuilderServices
                .uploadImageAttachment(formData)
                .then((res) => {
                    item.que_list[
                        tempObjIndex
                    ].form_question_execution_attachments = JSON.parse(
                        res.data
                    ).data;
                    this.$forceUpdate(); // Force UI update after successful upload
                })
                .catch((error) => {
                    console.error("Error uploading files:", error);
                });
        }
		if (
			item.que_list[tempObjIndex].fileURLArray.length >
					imageCount
				) {
					this.uploadFiles(tempObjIndex,item);
				}
        console.log("Files uploaded successfully!");
    }

    this.$forceUpdate(); // Force UI update
    return item.que_list; // Return updated que_list
},
async compressImage(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = (event) => {
					const img = new Image();
					img.onload = () => {
						const canvas = document.createElement("canvas");
						const ctx = canvas.getContext("2d");

						// Calculate new dimensions to maintain aspect ratio
						let newWidth = img.width;
						let newHeight = img.height;
						const maxSize = 500 * 1024; // 500 KB in bytes

						while (newWidth * newHeight * 4 > maxSize) {
							// * 4 for 4 bytes per pixel (RGBA)
							newWidth *= 0.9;
							newHeight *= 0.9;
						}

						canvas.width = newWidth;
						canvas.height = newHeight;

						ctx.drawImage(img, 0, 0, newWidth, newHeight);
						canvas.toBlob(
							(blob) => {
								const compressedFile = new File([blob], file.name, {
									type: "image/jpeg",
									lastModified: Date.now(),
								});
								resolve(compressedFile);
							},
							"image/jpeg",
							0.7
						); // JPEG compression quality 0.7
					};
					img.src = event.target.result;
				};
				reader.readAsDataURL(file);
			});
		},

		uploadFiles(tempObjIndex,item) {
			const formData = new FormData();
			const filesArray = item.que_list[tempObjIndex].filesArray;

			for (let i = 0; i < filesArray.length; i++) {
				formData.append("attachments", filesArray[i]);
				formData.append("storage", "task");
			}

			formBuilderServices
				.uploadImageAttachment(formData)
				.then((res) => {
					item.que_list[
						tempObjIndex
					].form_question_execution_attachments = JSON.parse(res.data).data; 

					// After successful upload, update UI to display uploaded images
					this.$forceUpdate();
				})
				.catch((error) => {
					console.error("Error uploading files:", error);
				});
		},
		show_comment(item) {
			item.show_comment = true;
			this.$forceUpdate();
			return item;
		},
		hide_comment(item) {
			item.show_comment = false;
			this.$forceUpdate();
			return item;
		},
		clear_selection(item, idx) {
			console.log(item, "item");
			if (item.form_question_info.input_type_info.name == "Yes / No") {
				this.green_color = "";
				this.red_color = "";
				item.boolean_input = null;
				item.button_no = null;
				item.button_yes = null;
				item.red_color = "";
				item.green_color = "";
				item.current_question_points = 0;
				let current_question_points = 0;
				for (let i = 0; i < this.preview_formItemArray.length; i++) {
					current_question_points +=
						this.preview_formItemArray[i].current_question_points != undefined
							? Number(this.preview_formItemArray[i].current_question_points)
							: 0;
				}
				this.current_question_points = current_question_points;
			}
			if (item.form_question_info.input_type_info.name == "Checklist") {
				item.checked = null;
			}
			if (item.form_question_info.input_type_info.name === "Timer") {
				// item.checked = null;
			}
			if (item.form_question_info.input_type_info.name === "Date") {
				item.date_input = null;
			}
			if (item.form_question_info.input_type_info.name === "Time") {
				item.time_input = null;
			}
			if (item.form_question_info.input_type_info.name === "Datetime") {
				item.datetime_input = null;
			}
			if (item.form_question_info.input_type_info.name == "Rating") {
				item.form_question_info.rating = null;
			}
			if (item.form_question_info.input_type_info.name == "Select any one") {
				item.input_option = null;
				for (
					let i = 0;
					i < item.form_question_info.input_options_list.length;
					i++
				) {
					item.form_question_info.input_options_list[i].checked = false;
				}
			}
			if (item.form_question_info.input_type_info.name == "Multiselect") {
				item.multiple_input_options = [];
				for (
					let i = 0;
					i < item.form_question_info.input_options_list.length;
					i++
				) {
					item.form_question_info.input_options_list[i].selected = false;
				}
			}
			if (
				item.form_question_info.input_type_info.name == "Long text" ||
				item.form_question_info.input_type_info.name == "Short text" ||
				item.form_question_info.input_type_info.name == "Number input"
			) {
				item.text_input = null;
				item.number_input = null;
			}
			if (
				item.form_question_info.input_type_info.name == "Temperature" ||
				item.form_question_info.input_type_info.name == "TPM"
			) {
				item.number_input = null;
				item.repeat_number_input = null;
				item.test_color = null;
				item.test_color_retest = null;
				item.show_temp_retest = false;
				item.test_color_tpm = null;
				item.test_color_tpm_retest = null;
				item.show_tpm_retest = false;
			}
			this.$forceUpdate();
			return item;
		},
		get_temperature_content(item, number) {
			if (item.number_input != "" && item.number_input != null) {
				if (
					number >= item.form_question_info.minimum_value &&
					number <= item.form_question_info.maximum_value
				) {
					item.show_temp_retest = false;
					item.test_color = "";
				} else {
					item.test_color = "#FF0000";
					item.test_color_retest = "";
					item.show_temp_retest = true;
				}
			} else {
				item.show_temp_retest = false;
				item.test_color = "";
			}
		},
		get_temperature_content_retest(item, number) {
			if (item.number_input != "") {
				if (
					number >= item.form_question_info.minimum_value &&
					number <= item.form_question_info.maximum_value
				) {
					item.test_color_retest = "";
				} else {
					item.test_color_retest = "#FF0000";
				}
			}
		},
		get_tpm_content(item, number) {
			if (item.number_input != "" && item.number_input != null) {
				if (
					number >= item.form_question_info.minimum_value &&
					number <= item.form_question_info.maximum_value
				) {
					item.show_tpm_retest = false;
					item.test_color_tpm = "";
				} else {
					item.test_color_tpm = "#FF0000";
					item.show_tpm_retest = true;
					item.test_color_tpm_retest = "";
				}
			} else {
				item.show_tpm_retest = false;
				item.test_color_tpm = "";
			}
		},
		get_tpm_content_retest(item, number) {
			if (item.number_input != "") {
				if (
					number >= item.form_question_info.minimum_value &&
					number <= item.form_question_info.maximum_value
				) {
					item.test_color_tpm_retest = "";
				} else {
					item.test_color_tpm_retest = "#FF0000";
				}
			}
		},
		get_radio_active(id, item, arr) {
			for (let i = 0; i < arr.length; i++) {
				if (id == arr[i].id) {
					arr[i].checked = arr[i].id;
				} else {
					arr[i].checked = false;
				}
			}
			this.$forceUpdate();
			return item, arr, id;
		},
		getAppropriateResponse() {
			// this.save_n_exit('Section')
			// this.$emit("save_filled_question");
			// this.get_on_load_data()
			// setTimeout(() => {
			// 	this.get_attachments(this.image_array);
			// }, 1000);
			this.$emit("get_updated_array", this.formDetails, this.current_question_idx);
			this.viewQuestionImagesDialog = false;

		},
		save_n_exit(val) {
			let proceedToCallAPI = false;
			let invalidReasons = [];

			this.preview_formItemArray.forEach((el) => {
				el.que_list.forEach((question) => {
					if (question.form_question_info.is_image_required) {
						if (question.form_question_execution_attachments.length == 0) {
							invalidReasons.push(
								`Upload mandatory image of '${question.form_question_info.name}'`
							);
						}
					}
					if (question.form_question_info.is_comment_required) {
						if (question.comment == null || question.comment.length == 0) {
							invalidReasons.push(
								`Enter mandatory comment of '${question.form_question_info.name}'`
							);
						}
					}
				});
			});
			console.log(invalidReasons, "invalidReasons");
			if (invalidReasons.length != 0) {
				proceedToCallAPI = false;
				this.$notify.error({
					title: "Fail",
					message: `${invalidReasons}`,
				});
			} else {
				proceedToCallAPI = true;
			}
			if (proceedToCallAPI) {
				let params = [];

				this.preview_formItemArray.forEach((el) => {
					el.que_list.forEach((question) => {
						let boolean_input = null;
						let datetime_input = null;
						let date_input = null;
						let time_input = null;
						let timer_input = [];
						let text_input = null;
						let number_input = null;
						let repeat_number_input = null;
						let input_option = null;
						let multiple_input_options = [];
						let form_question_execution_attachments = [];

						switch (question.form_question_info.input_type_info.name) {
							case "Yes / No":
								if (question.button_yes == true) {
									boolean_input = true;
								}
								if (question.button_no == true) {
									boolean_input = false;
								}
								break;
							case "Checklist":
								boolean_input = question.checked ? true : false;
								break;
							case "Datetime":
								datetime_input = moment(question.datetime_input).format(
									"YYYY-MM-DD HH:mm:ss"
								);
								break;
							case "Date":
								date_input = question.date_input;
								break;
							case "Time":
								time_input = question.time_input;
								break;
							case "Timer":
								question.form_question_info.stopwatches.forEach(
									(stopwatch, index) => {
										const { id, time } = stopwatch;
										if (id && time !== 0) {
											timer_input.push({
												id,
												seconds: time / 1000,
												serial_no: index + 1,
											});
										} else if (time !== 0) {
											timer_input.push({
												seconds: time / 1000,
												serial_no: index + 1,
											});
										}
									}
								);
								break;
							case "Long text":
							case "Short text":
								text_input = question.text_input;
								break;
							case "Number input":
							case "Temperature":
							case "TPM":
								number_input = question.number_input;
								break;
							case "Rating":
								number_input =
									question.form_question_info.rating == null
										? null
										: question.form_question_info.rating;
								break;
							case "Multiselect":
								question.form_question_info.input_options_list.forEach(
									(option) => {
										if (option.selected) {
											multiple_input_options.push(option.id);
										}
									}
								);
								break;
							case "Select any one":
								question.form_question_info.input_options_list.forEach(
									(option) => {
										if (option.checked != false) {
											input_option = option.id;
										}
									}
								);
								break;
						}

						if (question.fileURLArray !== undefined) {
							if (question.fileURLArray.length != 0) {
								question.fileURLArray.forEach((file) => {
									if (file.id) {
										form_question_execution_attachments.push({
											id: file.id,
											file_path: file.file_path,
											file_name: file.file_name,
										});
									}else{
										if (question.form_question_execution_attachments.length != 0) {
									question.form_question_execution_attachments.forEach(
										(attachment) => {
											form_question_execution_attachments.push({
												file_path: attachment.file_path,
												file_name: attachment.file_name,
											});
										}
									);
								}
									}
								});
							
							}
						}

						params.push({
							form_execution: this.formDetails.id,
							id: question.id,
							comment: question.comment,
							marked_as_na: question.marked_as_na,
							ticket_raised: question.ticket_raised,
							boolean_input,
							text_input,
							number_input: number_input != null ? Number(number_input) : null,
							repeat_number_input:
								repeat_number_input != null
									? Number(repeat_number_input)
									: null,
							input_option,
							multiple_input_options,
							form_question_execution_attachments,
							datetime_input,
							timer_input_data: timer_input,
							date_input,
							time_input,
						});
					});
				});

				formBuilderServices.submitQuestionInputFromUser(params).then((res) => {
					switch (val) {
						case "1":
							this.$emit("next_question");
							break;
						case "2":
							this.$emit("prev_question");
							break;
						case "Section":
							this.$emit("save_filled_question");
							break;
						case "5":
							this.$emit("prev_category", this.current_category_index);
							break;
						case "6":
							this.$emit("next_category", this.current_category_index);
							break;
					}
				});
			}
		},
		button_condition_no(item, idx, idxS) {
			this.current_question_points = 0;
			this.red_color = "";
			item.button_yes = false;
			item.button_no = true;
			item.red_color = item.button_no
				? "color:white; background:#FF0000; border-color:#FF0000"
				: "color:'#d26300'";
			item.green_color = "";
			for (
				let j = 0;
				j <
				this.preview_formItemArray[idxS].que_list[idx].form_question_info
					.expected_responses_list.length;
				j++
			) {
				if (
					this.preview_formItemArray[idxS].que_list[idx].form_question_info
						.expected_responses_list[j].expected_boolean_value ==
					!item.button_no
				) {
					this.preview_formItemArray[idxS].que_list[
						idx
					].current_question_points =
						this.preview_formItemArray[idxS].que_list[
							idx
						].form_question_info.expected_responses_list[j].points_on_trigger;
					this.current_question_points +=
						this.preview_formItemArray[idxS].que_list[
							idx
						].current_question_points;
				}
			}
			let current_question_points = 0;
			for (
				let i = 0;
				i < this.preview_formItemArray[idxS].que_list.length;
				i++
			) {
				if (
					this.preview_formItemArray[idxS].que_list[i].form_question_info
						.input_type_info.name == "Yes / No"
				) {
					current_question_points += Number(
						this.preview_formItemArray[idxS].que_list[i]
							.current_question_points != undefined
							? this.preview_formItemArray[idxS].que_list[i]
									.current_question_points
							: 0
					);
				}
			}
			this.current_question_points = current_question_points;
			let green = 0;
			// let red = 0;
			for (
				let i = 0;
				i < this.preview_formItemArray[idxS].que_list.length;
				i++
			) {
				if (
					this.preview_formItemArray[idxS].que_list[i].form_question_info
						.input_type_info.name == "Yes / No"
				) {
					if (this.preview_formItemArray[idxS].que_list[i].button_no != true) {
						green += 1;
					}
				}
			}
			if (green == 0) {
				this.red_color =
					"color:white; background:#FF0000; border-color:#FF0000";
			} else {
				this.red_color = "";
			}
			this.green_color = "";
			this.$forceUpdate();
			return item;
		},
		button_condition_yes(item, idx, idxS) {
			this.green_color = "";
			this.red_color = "";
			this.current_question_points = 0;
			item.button_yes = true;
			item.button_no = false;
			item.green_color = item.button_yes
				? "color:white; background:#41BE62; border-color:#41BE62"
				: "color:'#d26300'";
			item.red_color = "";
			for (
				let j = 0;
				j <
				this.preview_formItemArray[idxS].que_list[idx].form_question_info
					.expected_responses_list.length;
				j++
			) {
				if (
					this.preview_formItemArray[idxS].que_list[idx].form_question_info
						.expected_responses_list[j].expected_boolean_value ==
					item.button_yes
				) {
					this.preview_formItemArray[idxS].que_list[
						idx
					].current_question_points =
						this.preview_formItemArray[idxS].que_list[
							idx
						].form_question_info.expected_responses_list[j].points_on_trigger;
				}
			}
			let current_question_points = 0;
			for (
				let i = 0;
				i < this.preview_formItemArray[idxS].que_list.length;
				i++
			) {
				if (
					this.preview_formItemArray[idxS].que_list[i].form_question_info
						.input_type_info.name == "Yes / No"
				) {
					current_question_points += Number(
						this.preview_formItemArray[idxS].que_list[i]
							.current_question_points != undefined
							? this.preview_formItemArray[idxS].que_list[i]
									.current_question_points
							: 0
					);
				}
			}
			this.current_question_points = current_question_points;
			let red = 0;
			for (
				let i = 0;
				i < this.preview_formItemArray[idxS].que_list.length;
				i++
			) {
				if (
					this.preview_formItemArray[idxS].que_list[i].form_question_info
						.input_type_info.name == "Yes / No"
				) {
					if (this.preview_formItemArray[idxS].que_list[i].button_yes != true) {
						red += 1;
					}
				}
			}
			if (red == 0) {
				this.green_color =
					"color:white; background:#41BE62; border-color:#41BE62";
			} else {
				this.green_color = "";
			}
			this.red_color = "";
			this.$forceUpdate();
			return item;
		},
		collapse_item(item) {
			item.expanded = !item.expanded;
			this.$forceUpdate();
			return item;
		},
		expand_item(item) {
			item.expanded = !item.expanded;
			this.$forceUpdate();
			return item;
		},
		raise_ticket(item) {
			if (item.actions.length == 0) {
				this.current_obj_obj = item;
				this.$emit("raise", item);
			} else {
				alert("Action already raised");
			}
			console.log("item,", item);
		},
		next_question() {
			this.loading = true;
			this.save_n_exit("1");
		},
		prev_question() {
			this.loading = true;
			this.save_n_exit("2");
		},
		prev_category() {
			this.loading = true;
			this.save_n_exit("5");
		},
		next_category() {
			this.loading = true;
			this.save_n_exit("6");
		},
	},
};
</script>

<style>
.input-class-red .el-input__inner {
	border-radius: 12px !important;
	background: #ff0000;
	border-color: #ff0000;
	color: white;
	padding-left: 10px;
	height: 40px;
	width: 100%;
	background-position: -webkit-calc(100% - 20px) center;
	-webkit-transition: 0.5s;
	transition: 0.5s;
	font-size: 12px;
}
.input-class .el-input__inner {
	background: #ffffff;
	border-radius: 12px;
	padding-left: 10px;
	height: 40px;
	width: 100%;
	background-position: -webkit-calc(100% - 20px) center;
	-webkit-transition: 0.5s;
	transition: 0.5s;
	font-size: 12px;
}
.el-textarea .el-textarea__inner {
	display: block;
	resize: vertical;
	padding: 5px 15px;
	line-height: 1.5;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	width: 100%;
	font-size: inherit;
	color: #606266;
	background-color: #fff;
	background-image: none;
	border: 1px solid #dcdfe6;
	border-radius: 12px;
	-webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
	transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.el-textarea__inner {
	border-radius: 12px;
}
.flex-container {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-end;
}

.flex-item {
	margin-left: 10px; /* Adjust as needed */
	margin-top: 10px; /* Adjust as needed */
}
</style>
